module.exports = __webpack_public_path__ + "static/media/icon_filter.6b22b963.svg";